import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Glasses02 = function Glasses02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M10 14.5347c1.2335-.7129 2.7663-.7129 3.9999 0M2 15l.7015-7.0149c.0266-.266.0399-.399.0603-.513.2404-1.345 1.3594-2.3577 2.7217-2.4632C5.5991 5 5.7327 5 6 5m16 10-.7015-7.0149c-.0266-.266-.0399-.399-.0603-.513-.2404-1.345-1.3594-2.3577-2.7217-2.4632C18.4009 5 18.2673 5 18 5m-9.1716 7.1716c1.5621 1.5621 1.5621 4.0947 0 5.6568s-4.0947 1.5621-5.6568 0-1.5621-4.0947 0-5.6568 4.0947-1.5621 5.6568 0m12 0c1.5621 1.5621 1.5621 4.0947 0 5.6568s-4.0947 1.5621-5.6568 0-1.5621-4.0947 0-5.6568 4.0947-1.5621 5.6568 0"
    })
  }));
};
export default Glasses02;